import React, { FunctionComponent } from 'react'
import Button, { ButtonStyle } from '../../controls/Button/Button'
import { ObjectStatus, ProjectWorkObject } from '../../../responses/objects'
import { PERMISSIONS } from '../../../constants/permissions'
import { objectActions } from '../../../redux/data/object/object-actions'
import { useAnyPermissions, useBoolean, useRootDispatch } from '../../../utils/hooks'
import TaskOpenIcon from 'files/task-open.svg'
import TaskCloseIcon from 'files/task-closed.svg'
import { xor } from '../../../utils/utils'
import { Colors } from '../../../styles'

interface Props {
    className?: string,
    object: ProjectWorkObject,
    inactive?: boolean,
}

const ObjectStatusPicker: FunctionComponent<Props> = props => {
    const dispatch = useRootDispatch()
    const {state: hover, setTrue, setFalse} = useBoolean()

    const canChange = useAnyPermissions([PERMISSIONS.OBJECT.STATUS_CHANGE])
    const opened = props.object.status_id === ObjectStatus.OPENED

    return <Button
        className={props.className}
        buttonStyle={ButtonStyle.BORDERED}
        color={opened ? Colors.blue : Colors.green}
        inactive={props.inactive}
        onMouseEnter={setTrue}
        onMouseLeave={setFalse}
        onClick={() => canChange && dispatch(objectActions.startClose(props.object))}
    >
        {xor(opened, !hover) ? <TaskOpenIcon/> : <TaskCloseIcon/>}
        {
            opened ?
                (hover ?
                    'Закрыть' :
                    'Открыт') :
                (hover ?
                    'Открыть' :
                    'Закрыт')
        }
    </Button>
}

export default ObjectStatusPicker